import React, { useState } from "react";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

import { getSearchResults } from "../api/apiCalls";
import SingleSearch from "./SingleSearch";

function SearchFilter({ fontSize = "medium" }) {
  const [open, setOpen] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState(false);
  const [searchFailed, setSearchFailed] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = () => {
    const term = searchName.trim();

    if (term === "") {
      setError(true);
      setSearchFailed(false);
      setResults([]);
      return;
    }

    setLoading(true);
    setError(false);
    setSearchFailed(false);

    getSearchResults(term).then(
      (res) => {
        setResults(res);
        setLoading(false);

        if (res.length <= 0) {
          setSearchFailed(true);
        }
      },
      (err) => {
        console.log(err);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <button
        type="button"
        className="search-filter__trigger"
        aria-label="search"
        onClick={handleClickOpen}
      >
        <SearchIcon fontSize={fontSize} />
      </button>

      <Dialog
        open={open}
        maxWidth="md"
        fullWidth
        onClose={handleClose}
        className="search-dialog"
        PaperProps={{
          className: "search-dialog__paper",
          sx: { backgroundImage: "none" },
        }}
      >
        <DialogTitle className="search-dialog__title">
          Пребарај мобилни телефони / галантерија...
        </DialogTitle>

        <DialogContent className="search-dialog__content">
          <button
            type="button"
            onClick={handleClose}
            className="dialog__close"
            aria-label="close search"
          >
            <CloseIcon />
          </button>

          <div className="search-dialog__intro">
            {/* <span className="search-dialog__eyebrow">BuzzMobile Search</span> */}
            <p>
              Пронајди телефони, додатоци и поврзани производи со брзо
              пребарување.
            </p>
          </div>

          <div className="search__field__container">
            <TextField
              label="Име на телефон / галантерија"
              variant="outlined"
              onChange={(e) => setSearchName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              value={searchName}
              className="field__search"
            />
            <Button
              variant="contained"
              endIcon={<SearchIcon />}
              onClick={handleSearch}
              disabled={loading}
              className="field__btn"
            >
              {loading ? "Се вчитува..." : "Пребарај"}
            </Button>
          </div>

          <div className="search__results">
            {results.length > 0 ? (
              results.map((result, index) => (
                <SingleSearch {...result} key={index} />
              ))
            ) : searchFailed ? (
              <p className="search__empty">
                <i>Пронајдени 0 резултати</i>
              </p>
            ) : (
              <p className="search__placeholder">
                Внеси поим и притисни пребарај за да видиш резултати.
              </p>
            )}

            {error && (
              <Alert severity="warning" className="search__alert">
                Внесете збор за да почнете со пребарување
              </Alert>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default SearchFilter;
